var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { setDisplayName, getDisplayName } from 'recompose';
import { classnames } from '../../../lib/classNameBuilders';
export const makeIcon = (name) => {
    return (IconComponent) => {
        const Icon = (props) => {
            const { className } = props, rest = __rest(props, ["className"]);
            return (React.createElement(IconComponent, Object.assign({ className: classnames('icon', `icon--${name}`, className) }, rest)));
        };
        return setDisplayName(`Icon(${getDisplayName(IconComponent)})`)(Icon);
    };
};
//# sourceMappingURL=makeIcon.js.map